module.exports = __webpack_public_path__ + "assets/img/ri.dc131408.png";